import React from "react";
import { GenericPage } from "../../../../../pages";
import { clientRoutes } from "./administration-client.route";
import { planRoutes } from "./administration-plan.route";
import { subscriptionRoutes } from "./administration-subscription.route";
import { fileRoutes } from "./administration-files.route";
import { auditoriaRoutes } from "./administration-auditoria.route";
import { sriBrowserPoolRoutes } from "./administration-sri-browser-pool.route";
import { telegramChatsRoutes } from "./administration-telegram-chats.route";

export const administrationRoutes = [
  {
    path: "clients",
    element: <GenericPage />,
    children: clientRoutes,
  },
  {
    path: "auditoria",
    element: <GenericPage />,
    children: auditoriaRoutes,
  },
  {
    path: "plans",
    element: <GenericPage />,
    children: planRoutes,
  },
  {
    path: "files",
    element: <GenericPage />,
    children: fileRoutes,
  },
  {
    path: "subscriptions",
    element: <GenericPage />,
    children: subscriptionRoutes,
  },
  {
    path: "sri-browser-pool",
    element: <GenericPage />,
    children: sriBrowserPoolRoutes,
  },
  {
    path: "telegram-chats",
    element: <GenericPage />,
    children: telegramChatsRoutes,
  },
];
